const apiUrl = process.env.REACT_APP_API_URL;
export const GetAlumneId = async (id_usuari: String, token?: string) => {
    try {
        const headers: any = {
            'Content-Type': 'application/json'
        };
        const authToken = token || localStorage.getItem('authToken');
        if (authToken) {
            headers['Authorization'] = `Bearer ${authToken}`;
        }

        const response = await fetch(`${apiUrl}:8061/alumnes/${id_usuari}`, { headers });

        if (!response.ok) {
            console.error(`GetAlumneId error: ${response.status}`);
            return undefined;
        }

        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return undefined;
    }
};
